export default "__VITE_ASSET__DPcAkYeI__"